import { render, staticRenderFns } from "./gscInvoice.vue?vue&type=template&id=71989aa4"
import script from "./gscInvoice.vue?vue&type=script&lang=js"
export * from "./gscInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports